import VacancyForm from './VacancyForm';

export default VacancyForm;
